import {
  CreateHomeScreenBanner,
  CreateHomeScreenBannerVariables
} from './__generated__/CreateHomeScreenBanner'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateHomeScreenBanner($input: CreateHomeScreenBannerInputV2!) {
    createHomeScreenBanner: createHomeScreenBannerV2(input: $input) {
      ... on HomeScreenBannerV2 {
        id
        title
        description
        backgroundColor
        positionInFeed
        enabled
        buttons {
          title
          deepLinkUrl
        }
      }
      ... on HomeScreenBannerErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreateHomeScreenBanner = () =>
  useMutation<CreateHomeScreenBanner, CreateHomeScreenBannerVariables>(MUTATION)
